module.exports = __webpack_public_path__ + "img/fin-agent-save-snippet-light.1e1e06c.svg";